import {
  Component,
  ViewChild,
  Output,
  OnInit,
  Input,
  EventEmitter,
  HostListener,
} from '@angular/core';
import * as _ from 'lodash';
import * as debug from 'debug';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { Content, NavController } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { FeedPreset } from '../../providers/posts/posts';
import { NewsBrowserProvider } from '../../providers/news-browser/news-browser';
import { FriendshipsProvider } from '../../providers/friendships/friendships';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';

declare let CmKit: any;

@Component({
  selector: 'main-search',
  templateUrl: 'main-search.html',
})
export class MainSearchComponent implements OnInit {
  log = debug('app:MainSearchComponent');

  @ViewChild('searchBar') searchBar;
  @ViewChild('searchBody') searchBody;
  @ViewChild('searchFilters') searchFilters;
  @ViewChild('searchTabs') searchTabs;
  @ViewChild(Content) content: Content;

  @Input() showCancel = true;
  @Input() autoFocus = false;
  @Input() placeholder = 'Search';
  @Input() resultsContainer;
  @Input() searchTypes: any = {
    people: true,
    posts: true,
  };
  @Output() searchOpen = new EventEmitter();
  @Output() searchClose = new EventEmitter();

  searchText: string = '';
  invalidChars: string[] = ['*', '\\', '['];
  focusedSearch = false;
  feedPreset = FeedPreset;

  positioning = {
    searchTop: 0,
    searchBottom: 0,
  };
  doSearchDebounce;
  lastSearchText;
  searchId;
  results = {
    posts: [],
    people: [],
    recent: [],
    peopleMax: 5,
    loadingMorePeople: false,
  };
  subs = [];
  maxRecords = Infinity;
  infiniteScrollOn = false;
  navedToPost = false;

  subTabsActiveIndex = 0;
  subSlideTabs = _.filter(
    [
      { id: 'score', label: 'Popular' },
      { id: 'latest', label: 'Latest' },
      { id: 'alltime', label: 'All Time' },
      { id: 'friends', label: 'Friends' },
      { id: 'news', label: 'News' },
    ],
    t => _.size(t)
  );

  constructor(
    public tools: ToolsProvider,
    public crud: CrudApiProvider,
    public user: UserProvider,
    public friendships: FriendshipsProvider,
    public newsBrowser: NewsBrowserProvider,
    public userVerification: UserVerificationProvider,
    public navCtrl: NavController
  ) {
    this.doSearchDebounce = _.debounce(() => {
      this.doSearch();
    }, 250);

    this.subs.push(
      this.tools.on(`tag-click`, tagEvent => {
        console.warn('tagEvent', tagEvent);
        this.searchText = '#' + tagEvent;
        this.showSearch();
      })
    );

    this.subs.push(
      this.tools.on(`viewWillEnter`, view => {
        if (view.id === 'HomePage' && this.navedToPost) {
          this.navedToPost = false;
          this.focusedSearch = true;
        }
      })
    );
  }

  ngOnInit() {
    this.subTabsActiveIndex = parseInt(
      localStorage.getItem('feedIndex') || '0',
      10
    );
    // switch element to sit below the body
    if (_.get(this.searchBody, 'nativeElement')) {
        if (_.get(this.resultsContainer, '_elementRef.nativeElement')) {
          console.warn('container', this.resultsContainer);
          try {
            this.resultsContainer._elementRef.nativeElement.appendChild(
            this.searchBody.nativeElement
          );
        } catch (e) {
          console.warn('container erorr', e);
        }
      } else {
        document
        .querySelector('ion-app')
        .appendChild(this.searchBody.nativeElement);
        document
        .querySelector('ion-app')
        .appendChild(this.searchFilters.nativeElement);
        document
        .querySelector('ion-app')
        .appendChild(this.searchTabs.nativeElement);
      }
    }

    this.setFocus();
  }

  @HostListener('document:keypress', ['$event'])
  validCharacter(event: KeyboardEvent) {
    if (
      this.focusedSearch &&
      event &&
      _.includes(this.invalidChars, event.key)
    ) {
      event.preventDefault();
    }
  }

  setFocus() {
    if (this.autoFocus) {
      setTimeout(() => {
        try {
          const i = this.searchBar.nativeElement.querySelector('input');

          i && i.focus();
          // had to fouce the cursor to the end of the line for some reason
          i.setSelectionRange(100, 100);
        } catch (e) {}
      });
    }
  }

  doInfinite(infiniteScroll) {
    if (!this.infiniteScrollOn) {
      this.infiniteScrollOn = true;
      let st = this.searchText.replace(/“/g, '"').replace(/”/g, '"');
      this.searchId = _.uniqueId();
      this.postSearch(st, this.searchId).then(() => {
        infiniteScroll.complete();
        this.infiniteScrollOn = false;
      });
    }
  }

  showSearch() {
    setTimeout(() => {
      this.searchOpen.emit(true);
      this.tools.emit('searchOpen');
      this.focusedSearch = true;

      try {
        const box = this.searchBar.nativeElement.getBoundingClientRect();
        this.positioning.searchTop = box.bottom + 5;
      } catch (e) {}

      // force research
      this.lastSearchText = Math.random();

      this.doSearch();
    }, 200);
  }

  async scrollToTop() {
    this.content && this.content.scrollToTop(0);
  }

  async doSearch(forceSearch = false) {
    this.log('doSearch', forceSearch);
    this.results.posts = [];
    if (this.searchText.length === 0) {
      this.results = {
        posts: [],
        people: [],
        recent: [],
        peopleMax: 5,
        loadingMorePeople: false,
      };
      this.recentSearch('', this.searchId);
      this.tools.logAnalyticsEvent('trackCustom', 'search', {});
    }

    let st = this.searchText.replace(/“/g, '"').replace(/”/g, '"'),
      autocompleteOnly = false;

    if (forceSearch) {
      autocompleteOnly = false;
    } else {
      autocompleteOnly = _.size(st) <= 2;
    }

    let lastSearchId = `tab-${this.subTabsActiveIndex}` + st + autocompleteOnly;

    if (this.lastSearchText === lastSearchId || this.searchText.length === 0) {
      this.log('doSearch | return');  
      return;
    }

    this.lastSearchText = lastSearchId;
    this.log('starting search', st);

    this.searchId = _.uniqueId();

    return Promise.all(
      [
        !autocompleteOnly &&
          this.searchTypes.posts &&
          this.postSearch(st, this.searchId),
        !autocompleteOnly &&
          this.searchTypes.people &&
          this.peopleSearch(st, this.searchId),
        this.recentSearch(st, this.searchId),
      ].filter(d => d)
    ).then(() => {
      // Done
      this.log('results', this.results);
      this.rankingResults();
    });
  }

  private rankingResults() {
    // ranking people
    const exactMatchPeople = _.filter(this.results.people, item => {
      const name = `${_.trim(item.firstName)} ${_.trim(item.lastName)}`;
      const nameLower = name.toLowerCase();
      return (
        nameLower === _.trim(this.searchText.toLowerCase()) ||
        _.trim(item.username.toLowerCase()) ===
          _.trim(this.searchText.toLowerCase())
      );
    });

    _.map(exactMatchPeople, match => {
      _.remove(this.results.people, people => {
        return people === match;
      });
      this.results.people.unshift(match);
    });

    // ranking posts
    // let matchedItems = [];
    // _.filter(this.results.posts, (post) => {
    //   const matching = _.includes(post.text.toLowerCase(), this.searchText);
    //   if (matching) {
    //     matchedItems.push(post);
    //   }
    // });

    // _.map(matchedItems, (match) => {
    //   _.remove(this.results.posts, (post) => {
    //     return post === match;
    //   });
    //   this.results.posts.unshift(match);
    // });
  }

  private async recentSearch(stringText: string, id) {
    let items = [];

    try {
      items = JSON.parse(localStorage.getItem('main-search-recent')) || [];
    } catch (e) {}

    items = items.filter(item => {
      let missing = false;
      _.each(stringText.split(' '), s => {
        s = String(s || '').trim();
        if (s) {
          if (!new RegExp(s, 'i').test(item)) {
            missing = true;
          }
        }
      });
      return !missing && item !== stringText && item !== this.searchText;
    });

    this.results.recent = items;
  }

  private async peopleSearch(stringText: string, id) {
    try {
      const { data } = await this.crud.get('/api/search/users', {
        postType: { $ne: 'ARTICLE' },
        text: stringText,
      });

      // still active
      if (this.searchId === id) {
        this.results.people = data || [];
        this.results.peopleMax = 5;
        await this.loadMorePeople(0);
      }
    } catch (error) {
      this.log('Error getting people', error);
    } finally {
    }
  }

  private async postSearch(stringText: string, id) {
    try {
      this.log('postSearch', stringText, id);

      const postsToSkip = _.map(this.results.posts, '_id');

      if (_.size(postsToSkip) > 250) {
        // start over ... in future we will have better search...sorry
        this.scrollToTop;
        this.results.posts = [];
      }
      const { data } = await this.crud.get('/api/search/posts', {
        text: stringText.replace(/#/g, 'HASH_'),
        feed: this.subSlideTabs[this.subTabsActiveIndex].id,
        skipIds: JSON.stringify(postsToSkip),
      });

      if (_.size(data) < 25) {
        this.infiniteScrollOn = false;
      }

      // still active
      if (this.searchId === id) {
        if (!_.size(this.results.posts)) {
          this.results.posts = data || [];
        } else {
          let postsClone = _.cloneDeep(this.results.posts);
          const ids = _.map(postsClone, '_id');
          _.each(data, p => {
            if (!_.includes(ids, p._id)) {
              this.results.posts.push(p);
            }
          });
        }
      }
    } catch (error) {
      this.log('Error getting post', error);
    } finally {
    }
  }

  close(event, clear?, post?) {
    event.stopPropagation();

    try {
      this.content && this.content.scrollToTop(0);
    } catch (e) {}

    if (post?._id) {
      setTimeout(() => {
        this.tools.navigateToPost(post, this.navCtrl, { skipTab: true });
      }, 100);
      this.focusedSearch = false;
      this.navedToPost = true;
    } else {
      setTimeout(() => {
        this.searchClose.emit(true);
        this.tools.emit('searchClose');
        this.focusedSearch = false;
        if (clear) {
          this.searchText = '';
          this.lastSearchText = Math.random();
        }
      });
    }

    if (this.searchText) {
      let items = [];

      try {
        items = JSON.parse(localStorage.getItem('main-search-recent')) || [];
      } catch (e) {}

      items.unshift(this.searchText);
      items = items.slice(0, 10);

      let found = {};

      items = items.filter(item => {
        item = String(item).toLowerCase();
        let f = found[item];
        found[item] = true;
        return !f;
      });

      localStorage.setItem('main-search-recent', JSON.stringify(items));
    }
  }

  async loadMorePeople(n = 5) {
    this.results.peopleMax += n;
    this.results.loadingMorePeople = true;
    this.log('loadign more people');
    await Promise.all(
      _.map(this.results.people, (p, idx) => {
        if (idx < this.results.peopleMax) {
          return this.crud
            .get(`/api/friends/${this.user.get('_id')}/${p._id}`)
            .then(res => {
              this.log('got friendship', res);
              if (res.data) {
                p.friendship = res.data;
              } else {
                p.noFriendship = true;
              }
            });
        }
      }).filter(d => d)
    );
    this.results.loadingMorePeople = false;
  }

  async requestFriendship(person) {
    if (!(await this.userVerification.isVerified())) {
      return;
    }

    const req = this.friendships.requestFriendship(person);
    if (req) {
      person.friendship = person;
      person.noFriendship = false;
    }
  }

  stopEvent(event) {
    this.log('will kill event', event);
    try {
      event.preventDefault();
      event.stopPropagation();
    } catch (e) {}
  }

  ngOnDestroy() {
    try {
      this.searchBody.nativeElement.remove();
      this.searchFilters.nativeElement.remove();
      this.searchTabs.nativeElement.remove();
    } catch(e){}
      _.each(this.subs, fn => {
        // works for event emitter and observables
        if (fn && fn.unsubscribe) {
          fn.unsubscribe();
        } else {
          fn && fn();
        }
      });
  }

  async changeActiveTabIndex(event) {
    this.subTabsActiveIndex = _.findIndex(
      this.subSlideTabs,
      t => t.id === event.id
    );

    localStorage.setItem('feedIndex', `${this.subTabsActiveIndex}`);
    this.log('changeActiveTabIndex | call doSearch', this.subTabsActiveIndex);
    this.doSearch(true);
    // alert('need to search the feed selected');
  }
}



// WEBPACK FOOTER //
// ./src/components/main-search/main-search.ts